import React from 'react'
import { ErrorScreen } from './common.coffee'
import * as crashReporter from './crash_reporter.coffee'

export default class ErrorBoundary extends React.Component
  constructor: (props) ->
    super props
    @state =
      hasError: false
      error: null

  logError: (error) ->
    if window.app?.trackError?
      window.app.trackError(error)
    else
      console.error "Error without app!"
      console.dir error

  # The crash reports ITSELF (card 6aad7bb96e6a1e18a090353b): one CrashLog row
  # with the error, the component stack and everything the reporter knows.
  # `reported` drives the copy below — the screen used to promise logs were
  # sent while nothing left the device.
  reportCrash: (error, info) ->
    kind = if error?.name is 'ChunkLoadError' then 'chunkload' else 'boundary'
    # WHICH chunk, and how hard we tried — card 6aad9e4dbb8767fbeba89f2c.
    # lazy_route stamps these on the error it finally gives up on, so the row
    # says whether the retries are rescuing anyone rather than leaving us to
    # guess from the absence of reports. Absent for every other kind of crash.
    context = {}
    context.chunk = error.chunkName if error?.chunkName?
    context.chunkAttempts = error.chunkAttempts if error?.chunkAttempts?
    crashReporter.report(kind, error, {componentStack: info?.componentStack, context: context})
      .then((ok) => @setState {reported: ok})
      .catch(=> @setState {reported: false})

  componentDidCatch: (error, info) ->
    # note: the actual error tends NOT to match the actual root cause, which leads
    #     : to a lot of unnecessary and misleading logging.
    realError = info?.componentStack || error

    @setState
      hasError: true
      error: error
      realError: realError
      reported: null

    # log the error
    @logError(realError)
    @reportCrash(error, info)

  # Honest copy: the sentence tracks what the reporter actually managed to do.
  reportLine: ->
    switch @state.reported
      when true then 'This error has been reported to our team.'
      when false then 'We could not report this error automatically.'
      else 'We are reporting this error to our team.'

  render: ->
    if @state.hasError
      if @state.error.name is 'ChunkLoadError'
        <ErrorScreen showVersionInfo>
          <p>
            <strong>Please check your internet connection. </strong>
            Our application is having trouble reaching our servers.
            If the problem persists, please contact support, let them know that you have seen this message, and let them know which device, browser, and operating system you are using.
          </p>
        </ErrorScreen>
      else
        <ErrorScreen showVersionInfo error={@state.realError}>
          <p>
            We have encountered an error. {@reportLine()}{' '}
            The system works best on Chrome or Safari.
            If you contact support, please let them know that you have seen this message, and let them know which device, browser, and operating system you are using.
          </p>
        </ErrorScreen>
    else
      return @props.children
